import { defineStore } from 'pinia';
import type { IProduct } from '~/modules/catalog/types/product';

export const useVisitorStore = defineStore('visitorStore', () => {

  const { $api } = useNuxtApp();

  const visitorID = ref<number | undefined>();

  const favoriteCount = ref<number>(0);
  const favoriteItems = ref<IProduct[]>([]);
  const favoriteTotal = ref<number>(0);

  const activeIDFavoriteList = ref<number[]>([]);

  const setVisitorID = (id: number) => visitorID.value = id;
  const setFavoriteCount = (count: number) => favoriteCount.value = count;
  const setFavoriteItems = (items: IProduct[]) => favoriteItems.value = items;
  const setFavoriteTotal = (value: number) => favoriteTotal.value = value;
  const toggleFavoriteList = (id: number) => activeIDFavoriteList.value.includes(id) ? activeIDFavoriteList.value.splice(activeIDFavoriteList.value.indexOf(id), 1) : activeIDFavoriteList.value.push(id);

  const setupVisitorID = async (): Promise<void> => {
    const { data, success, message, errors } = await $api.visitors.getCurrentVisitorId();

    if (success && data) {
      setVisitorID(data.id);
    }

    if (!success) {
      throw message;
    }
  };

  const getViewedProducts = async () => {
    if (!visitorID.value) return [];

    const { data, success } = await $api.visitors.getViewedProducts(visitorID.value);

    if (success && data) {
      return data.items;
    }

    return [];
  };

  watch(() => visitorID.value, (newVal, oldVal) => {
    if (newVal !== oldVal) {
      // alert('user ID изменился');
    }
  });

  watch(() => favoriteItems.value, (newVal, oldVal) => {
    activeIDFavoriteList.value = newVal.map((item) => item.id);
  });

  return {
    visitorID,
    favoriteCount,
    favoriteItems,
    favoriteTotal,
    activeIDFavoriteList,
    setFavoriteCount,
    setFavoriteItems,
    setFavoriteTotal,
    setupVisitorID,
    toggleFavoriteList,
    getViewedProducts,
  };
});
